// @flow
import { takeLatest, put, all, call } from 'redux-saga/effects';
import { VERIFY_EMAIL } from './EmailVerification.constants';
import { verifyEmailSuccess, verifyEmailFailure } from './EmailVerification.actions';
import { axiosLayer7Client } from '../../../config/axios-clientFilView';

export function* verfiyEmail() {
  const regex = new RegExp(`[\\?&]${'token'}=([^&#]*)`);
  const queryStr = window.location.href;
  const results = regex.exec(queryStr);
  let tokenVal;
  if (results !== null) {
    tokenVal = decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
  const dataToBePosted = {
    token: tokenVal,
  };
  try {
    const res = yield call(axiosLayer7Client.post, 'email/verify ', dataToBePosted);
    if (res.data.code === '200') {
      yield put(verifyEmailSuccess());
    } else {
      yield put(verifyEmailFailure({ name: 'ErrorMock', organisation: 'FIL' }));
    }
  } catch (err) {
    yield put(verifyEmailFailure({ name: 'ErrorMock', organisation: 'FIL' }));
  }
}
export default function* EmailVerificationSaga() {
  yield all([takeLatest(VERIFY_EMAIL, verfiyEmail)]);
}
